import Swal from 'sweetalert2'

export type TipoAlerta = 'success' | 'error' | 'warning' | 'info'

const iconos: Record<TipoAlerta, TipoAlerta> = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
}

export function notificar(mensaje: string, tipo: TipoAlerta = 'success'): void {
  void Swal.fire({
    toast: true,
    position: 'top-end',
    icon: iconos[tipo],
    title: mensaje,
    showConfirmButton: false,
    timer: 4200,
    timerProgressBar: true,
  })
}

export function mostrarCarga(mensaje: string): void {
  void Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(),
  })
}

export function cerrarCarga(): void {
  if (Swal.isLoading()) Swal.close()
}

export function mostrarSesionExpirada(extender: () => Promise<void>, _cerrar: () => void): void {
  void Swal.fire({
    icon: 'warning',
    title: 'La sesión está por expirar',
    text: 'Puede extenderla sin salir de la vista actual o cerrar sesión por completo.',
    showCancelButton: true,
    confirmButtonText: 'Extender sesión',
    cancelButtonText: 'Cerrar sesión',
    allowOutsideClick: false,
  }).then((resultado) => {
    if (resultado.isConfirmed)
      void extender().catch(() => {
        notificar('No fue posible extender la sesión. Puede intentarlo nuevamente.', 'error')
      })
    else if (resultado.dismiss === Swal.DismissReason.cancel) _cerrar()
  })
}

export function mostrarDialogo(mensaje: string, tipo: TipoAlerta = 'info'): void {
  void Swal.fire({
    icon: iconos[tipo],
    title: tipo === 'error' ? 'No fue posible completar la acción' : 'Información',
    text: mensaje,
    confirmButtonText: 'Aceptar',
  })
}
